var ChatroomBuilder = /** @class */ (function () {
    function ChatroomBuilder() {
        this.chatroom = {
            createdAt: 0,
            createdBy: '000-111-000',
            error: 'error',
            id: '000-111-000',
            messages: [],
            unreadCount: 1,
            typingStatus: [],
        };
    }
    ChatroomBuilder.prototype.withCreatedBy = function (createdBy) {
        this.chatroom.createdBy = createdBy;
        return this;
    };
    ChatroomBuilder.prototype.withMessages = function (messages) {
        this.chatroom.messages = messages;
        return this;
    };
    ChatroomBuilder.prototype.withUnreadCount = function (unreadCount) {
        this.chatroom.unreadCount = unreadCount;
        return this;
    };
    ChatroomBuilder.prototype.withId = function (id) {
        this.chatroom.id = id;
        return this;
    };
    ChatroomBuilder.prototype.withError = function (error) {
        this.chatroom.error = error;
        return this;
    };
    ChatroomBuilder.prototype.withTypingStatus = function (typingStatus) {
        this.chatroom.typingStatus = typingStatus;
        return this;
    };
    ChatroomBuilder.prototype.build = function () {
        return this.chatroom;
    };
    return ChatroomBuilder;
}());
export { ChatroomBuilder };
var ChatroomMessageBuilder = /** @class */ (function () {
    function ChatroomMessageBuilder() {
        this.chatroomMessage = {
            age: '12 minutes',
            chatroomId: '000-111-000',
            createdAt: 0,
            createdAtFormatted: 'Aug 12 2018',
            id: '000-111-000',
            messageParts: [],
            sender: { userId: '000-111-000' },
            summary: 'muy bueno',
        };
    }
    ChatroomMessageBuilder.prototype.withAge = function (age) {
        this.chatroomMessage.age = age;
        return this;
    };
    ChatroomMessageBuilder.prototype.withChatroomId = function (chatroomId) {
        this.chatroomMessage.chatroomId = chatroomId;
        return this;
    };
    ChatroomMessageBuilder.prototype.withCreatedAt = function (createdAt) {
        this.chatroomMessage.createdAt = createdAt;
        return this;
    };
    ChatroomMessageBuilder.prototype.withCreatedAtFormatted = function (createdAtFormatted) {
        this.chatroomMessage.createdAtFormatted = createdAtFormatted;
        return this;
    };
    ChatroomMessageBuilder.prototype.withId = function (id) {
        this.chatroomMessage.id = id;
        return this;
    };
    ChatroomMessageBuilder.prototype.withMessageParts = function (messageParts) {
        this.chatroomMessage.messageParts = messageParts;
        return this;
    };
    ChatroomMessageBuilder.prototype.withSender = function (sender) {
        this.chatroomMessage.sender = sender;
        return this;
    };
    ChatroomMessageBuilder.prototype.withSummary = function (summary) {
        this.chatroomMessage.summary = summary;
        return this;
    };
    ChatroomMessageBuilder.prototype.build = function () {
        return this.chatroomMessage;
    };
    return ChatroomMessageBuilder;
}());
export { ChatroomMessageBuilder };
;
//# sourceMappingURL=chatroom.builder.js.map